<template lang="pug">
#bloco-totalizador-monitoramento-socioambiental(
    element-loading-background='rgb(255 255 255 / 0%)'
)
    transition(name='el-fade-in-linear')
        .bloco-totalizador-monitoramento-socioambiental-container
            h3 {{ $t('mensagens.monitoramentoSocioambiental.totalizadores.titulo')}}
            .bloco-totalizador-monitoramento-socioambiental__bloco(
                v-loading='carregando'
            )
                BaseBlocoTotalizador(
                    v-for='resultado in resultados',
                    :key='resultado.texto',
                    :texto='internacionalizarTotalizadores(resultado.texto)',
                    :numero='resultado.valor'
                )
                    template(slot='icone')
                        i(:class='resultado.classe' :title='resultado.info ? $t("mensagens.monitoramentoSocioambiental.totalizadores.labels." + resultado.info) : ""')
</template>

<script>
import BaseBlocoTotalizador from '@/components/monitoramento/BaseBlocoTotalizador';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';

export default {
    name: 'BlocoTotalizadorMonitoramentoSocioambiental',
    props: {
        filtros: {
            type: Object,
            default: () => {}
        },
        areasMonitoradas: {
            type: Object,
            default: () => null
        }
    },
    components: {
        BaseBlocoTotalizador
    },
    data() {
        return {
            resultados: [],
            carregando: true,
            paginacao: {
                tamanho: null,
                pagina: null,
                ordenacao: null
            }
        };
    },

    async mounted() {
        await this.buscarTotalizadores();
    },
    watch: {
        filtros() {
            this.buscarTotalizadores();
        }
    },
    methods: {
        async buscarTotalizadores() {
            try {
                this.carregando = true;
                const { data } =
                    await AreasMonitoradasService.buscarTotalizadoresMonitoradasSocioambiental(
                        this.filtros,
                        this.paginacao
                    );
                this.resultados = data;
                this.carregando = false;
            } catch {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao buscar os totalizadores das áreas monitoradas'
                });
            }
        },
        internacionalizarTotalizadores(texto) {
            const textoFormatado = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            const textoFormatadoSemEspacos = textoFormatado.replace(/\s+/g, '-');
            return this.$t(`mensagens.monitoramentoSocioambiental.totalizadores.labels.${textoFormatadoSemEspacos}`);
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-totalizador-monitoramento-socioambiental {
    min-height: 122.2px;

    .bloco-totalizador-monitoramento-socioambiental-container {
        h3 {
            margin-bottom: 10px;
            color: var(--black);
            font-weight: 500;
        }
        .bloco-totalizador-monitoramento-socioambiental__bloco {
            width: 100%;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 33.33% 33.33% 33.33%;
        }
    }
}
</style>
